import { enchantingGreeceAthensMykonosProduct } from './enchantingGreeceAthensMykonosData';
import { spectacularAthensOlympiaDelphiProduct } from './spectacularAthensOlympiaDelphiData';
import { romanticGreeceAthensSantoriniProduct } from './romanticGreeceAthensSantoriniData';
import { majesticGreeceAthensMykonosSantoriniProduct } from './majesticGreeceAthensMykonosSantoriniData';
import { exoticGreeceIslandHoppingProduct } from './exoticGreeceIslandHoppingData';

export const greeceProducts = [
  enchantingGreeceAthensMykonosProduct,
  spectacularAthensOlympiaDelphiProduct,
  romanticGreeceAthensSantoriniProduct,
  majesticGreeceAthensMykonosSantoriniProduct,
  exoticGreeceIslandHoppingProduct
];
export const greeceTours = [];
export const greeceBySlug = {};
